<template>
  <div>
    <TDialog persistent v-model="dialogOpen">
      <template #activator="{ open }">
        <TBtn
          :disabled="disabled"
          :color="!disabled ? 'green' : 'gray'"
          @click="open"
        >
          Submit new question
          <t-icon right> add_comment </t-icon>
        </TBtn>
      </template>
      <template #content>
        <t-card dialog v-if="page === 1" :key="1">
          <t-card-title class="tw:flex-nowrap">
            <t-icon left>forum</t-icon>
            <h3 class="tw:sta-heading" style="flex: 1 1 100%">
              Have a question about this RFP?
            </h3>
          </t-card-title>
          <t-card-text class="tw:py-0">
            <span>
              Please only submit one question at a time. Once answered, this
              question and answer will be visible to all participants in this
              project.</span
            >
            <TTextarea
              v-model="question"
              placeholder="Ask us your question here..."
              class="tw:mt-4"
            />
          </t-card-text>
          <t-card-actions class="tw:justify-between">
            <TBtn @click="dialogOpen = false" flat>
              <span>Cancel</span>
            </TBtn>
            <TBtn
              id="rfi-submit-button"
              @click="submitAndClose"
              :disabled="!question"
              flat
            >
              <span>Submit</span>
            </TBtn>
          </t-card-actions>
        </t-card>
        <t-card dialog v-if="page === 2" :key="2">
          <t-card-title>
            <t-icon left>rocket_launch</t-icon>

            <h3 class="tw:sta-heading">Thank you!</h3>
          </t-card-title>
          <t-card-text class="tw:text-base">
            Check back here for the answer to your question. We update the
            Q&amp;A tab of this RFP page regularly as answers come in.
          </t-card-text>
          <t-card-actions class="tw:justify-between">
            <TBtn id="rfi-close-button" @click="dialogOpen = false" flat>
              <span>Close</span>
            </TBtn>
            <TBtn id="rfi-submit-another-button" @click="page = 1" flat>
              <span>Submit Another Question</span>
            </TBtn>
          </t-card-actions>
        </t-card>
      </template>
    </TDialog>
  </div>
</template>

<script>
export default {
  name: "RfiDialog",
  props: {
    rfpId: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      question: null,
      confirmDialogOpen: false,
      dialogOpen: false,
      page: 1,
    };
  },
  methods: {
    async submitAndClose() {
      this.$beacon.rfiCreate(this.rfpId);
      await this.$api.RFIs.create(this.rfpId, this.question);
      this.page = 2;
      this.question = null;
    },
  },
  watch: {
    dialogOpen() {
      this.$beacon.rfiFormSetView(this.dialogOpen, this.rfpId);
      if (!this.dialogOpen) {
        this.$emit("close");
      }
    },
  },
};
</script>
